import { createRoute } from '@tanstack/react-router';

import { EditorPage } from '$/pages/EditorPage/pages/EditorPage';
import { useEditorStore } from '$/pages/EditorPage/stores/useEditorStore';
import { EditorRouteLayout } from '$/routes/Layouts/EditorLayout';
import { filterOptionsQuery } from '$/services/usecases/filter/queries';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const EditorRoute = createRoute({
  getParentRoute: () => EditorRouteLayout,
  path: '/editor/$id',
  component: EditorPage,
  onEnter: () => {
    useEditorStore.useResetStore();
  },
  loader: ({ context: { client } }) => {
    useCollectionStore.setState({ filter: undefined });
    void client.ensureQueryData(filterOptionsQuery()).then((filter) => {
      useCollectionStore.setState({ filter });
    });
  },
});
